export class Session {
    jwt: string;
    userId: number;
    username: string;
    branchOffice: number;
    impersonationUserName: string;
    impersonationUserId: number;
}
